// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260921.1790022229/static/js/" + chunkId + "." + {"249":"f762f41e","463":"1661b4bd"}[chunkId] + ".chunk.js";
};